import React from 'react';
import '../styles.css';

export default function Contact() {
  return (
    <section className="contact">
      <h2>Contact Us</h2>
      <form className="contact__form">
        <label>
          Name
          <input type="text" required />
        </label>
        <label>
          Email
          <input type="email" required />
        </label>
        <label>
          Message
          <textarea rows="4" required />
        </label>
        <button type="submit">Send Message</button>
      </form>
    </section>
  );
}
